import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "../sections/Hero";
import Ribbon from "../sections/Ribbon";
import About from "../sections/About";
import Services from "../sections/Services";
import WhyChoose from "../sections/WhyChoose";
import Process from "../sections/Process";
import Stats from "../sections/Stats";
import ServiceArea from "../sections/ServiceArea";
import CTA from "../sections/CTA";

export default function Home() {
  const loc = useLocation();
  useEffect(() => {
    if (loc.hash) {
      const id = loc.hash.replace("#", "");
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 300);
    } else {
      window.scrollTo(0, 0);
    }
  }, [loc]);

  return (
    <main data-testid="home-page">
      <Hero />
      <Ribbon />
      <About />
      <Services />
      <WhyChoose />
      <Process />
      <Stats />
      <ServiceArea />
      <CTA />
    </main>
  );
}
